import React from 'react';
import { Link } from 'react-router-dom';
import './BlogPreview.css';
import { blogsByDate } from '../data/blogs';

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

const BlogPreview = () => {
  const latest = blogsByDate.slice(0, 3);

  return (
    <section id="blog" className="blog-preview">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">From the Blog</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Reflections, lessons and reminders from the rich tradition of Islamic
            knowledge written for the modern reader.
          </p>
        </div>

        <div className="blog-preview-grid">
          {latest.map((blog) => (
            <Link
              key={blog.id}
              to={`/blog/${blog.id}`}
              className="blog-card"
              aria-label={`Read: ${blog.title}`}
            >
              <div
                className="blog-card-cover"
                style={{ background: blog.coverGradient }}
              >
                <span className="blog-card-cover-icon" aria-hidden="true">
                  {blog.coverIcon}
                </span>
                <div className="blog-card-cover-overlay" />
              </div>

              <div className="blog-card-body">
                <div className="blog-card-meta">
                  <span className="blog-card-date">{formatDate(blog.date)}</span>
                  <span className="blog-card-dot" aria-hidden="true">•</span>
                  <span className="blog-card-read">{blog.readTime} min read</span>
                </div>
                <h3 className="blog-card-title">{blog.title}</h3>
                <p className="blog-card-excerpt">{blog.excerpt}</p>
                <div className="blog-card-footer">
                  <span className="blog-card-author">By {blog.author}</span>
                  <span className="blog-card-cta">
                    Read article
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="blog-preview-cta">
          <Link to="/blog" className="btn btn-primary blog-preview-btn">
            View All Articles
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
